import AdminCertificatesKpisPanel from "../components/kpis/AdminCertificatesKpisPanel";

const AdminKpisPage = () => {
  return <AdminCertificatesKpisPanel />;
};

export default AdminKpisPage;
